// MDCF report previews — Odia MDM monthly bill + English PM POSHAN MDCF.
// Render-only; print styles in index.css (.mdcf-print).
import { MONTH_OPTIONS } from "@/lib/mdcf";

const TD = "border border-black px-2 py-1 text-[12px] align-middle";
const TDC = "border border-black px-2 py-1 text-[12px] align-middle text-center";
const TH = "border border-black px-2 py-1 text-[12px] font-bold text-center align-middle";

const CATEGORIES = [
  { key: "balBatika", label: "ବାଲ ବାଟିକା" },
  { key: "primaryClass", label: "ପ୍ରାଥମିକ ଶ୍ରେଣୀ" },
  { key: "upperPrimaryClass", label: "ଉଚ୍ଚ ପ୍ରାଥମିକ ଶ୍ରେଣୀ" },
  { key: "upperSchool", label: "ଉଚ୍ଚ ବିଦ୍ୟାଳୟ" },
];

const FIN = [
  { key: "previousBalance", label: "ପୂର୍ବ ଜମା" },
  { key: "received", label: "ଗ୍ରହଣ" },
  { key: "expense", label: "ଖର୍ଚ୍ଚ" },
  { key: "remaining", label: "ଅବଶିଷ୍ଟ" },
];

const num = (v) => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
};

function groceryTotal(items, prefix) {
  const t = items.reduce((s, it) => s + num(it[`${prefix}_price`]), 0);
  return t === 0 ? "" : String(Number(t.toFixed(2)));
}
function groceryQtyTotal(items, prefix) {
  const t = items.reduce((s, it) => s + num(it[`${prefix}_qty`]), 0);
  return t === 0 ? "" : String(Number(t.toFixed(2)));
}

export function OdiaMdmReport({ data }) {
  const { general, monthly } = data;
  const monthOdia = general.month ? general.month.split("/")[0].trim() : "";
  const enrolByClass = general.enrolmentByClass || { balBatika: 0, primaryClass: 0, upperPrimaryClass: 0, upperSchool: 0 };
  // Render "--" for classes with 0 enrolment (only if at least one class IS enrolled,
  // otherwise show empty so brand new schools don't see dashes everywhere).
  const anyEnrolled = (enrolByClass.balBatika + enrolByClass.primaryClass + enrolByClass.upperPrimaryClass + enrolByClass.upperSchool) > 0;
  const isClassActive = (k) => !anyEnrolled || (enrolByClass[k] || 0) > 0;
  const dashIfInactive = (k, v) => (isClassActive(k) ? v : "--");

  const bankRows = [...monthly.bankAccounts];
  while (bankRows.length < 12) {
    bankRows.push({ slNo: String(bankRows.length + 1), committeeName: "", bankAccountNo: "", ifscBranchName: "", amount: "" });
  }

  return (
    <div className="mdcf-page bg-white p-8 text-ink-900" data-testid="mdcf-odia-report" lang="or">
      <p className="text-right text-[12px]" data-testid="odia-mdm-school-meta">
        ବିଦ୍ୟାଳୟର କ୍ର. ନଂ - {general.schoolSerialNo || "________"} | UDISE Code - <b>{general.udiseCode || "________"}</b>
      </p>
      <h2 className="my-2 text-center text-[16px] font-bold">
        {general.blockNP ? `${general.blockNP} ଖଣ୍ଡ ଅନ୍ତର୍ଗତ ` : ""}ବିଦ୍ୟାଳୟ ସମୂହରେ ଚାଲୁରହିଥିବା ମଧ୍ୟାହ୍ନ ଭୋଜନର ମାସିକ ବିବରଣୀ ଫର୍ମ
      </h2>

      <table className="w-full border-collapse">
        <tbody>
          <tr>
            <td className={TD}>୧. ବିଦ୍ୟାଳୟର ନାମ - <b>{general.schoolName}</b></td>
            <td className={TD}>ମାସ / ବର୍ଷ - <b>{monthOdia} {monthOdia && general.year ? "/" : ""} {general.year}</b></td>
            <td className={TD}>ମୋଟ ପିଲା - <b>{general.totalChildren}</b></td>
          </tr>
        </tbody>
      </table>

      <table className="mt-2 w-full border-collapse">
        <thead>
          <tr>
            <th className={TH}> </th>
            <th className={TH}>୨. ବିଦ୍ୟାଳୟର ମୋଟ ଶିକ୍ଷାର୍ଥୀ ସଂଖ୍ୟା</th>
            <th className={TH}>୩. ବିଦ୍ୟାଳୟର ମୋଟ କାର୍ଯ୍ୟ ଦିବସ</th>
            <th className={TH}>୪. ମଧ୍ୟାହ୍ନ ଭୋଜନ ପରିବେଷଣ କରାଯାଇଥିବା ଦିନର ପ୍ରକୃତ ସଂଖ୍ୟା</th>
            <th className={TH}>୫. ମାସରେ ପରିବେଷଣ କରାଯାଇଥିବା ମୋଟ ଖାଦ୍ୟ</th>
          </tr>
        </thead>
        <tbody>
          {CATEGORIES.map((c) => (
            <tr key={c.key}>
              <th className={TH}>{c.label}</th>
              <td className={TDC} data-testid={`odia-sec2-students-${c.key}`}>{dashIfInactive(c.key, monthly.section2.totalStudents[c.key])}</td>
              <td className={TDC} data-testid={`odia-sec2-workdays-${c.key}`}>{dashIfInactive(c.key, monthly.section2.totalWorkingDays[c.key])}</td>
              <td className={TDC} data-testid={`odia-sec2-served-${c.key}`}>{dashIfInactive(c.key, monthly.section2.mdmServedDays[c.key])}</td>
              <td className={TDC} data-testid={`odia-sec2-foodexp-${c.key}`}>{dashIfInactive(c.key, monthly.section2.totalFoodExpense[c.key])}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <table className="mt-2 w-full border-collapse">
        <thead>
          <tr><th colSpan={5} className={TH}>୬. ଆର୍ଥିକ ବିବରଣୀ (ଟଙ୍କାରେ)</th></tr>
          <tr>
            <th className={TH}> </th>
            {FIN.map((f) => <th key={f.key} className={TH}>{f.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {CATEGORIES.map((c) => (
            <tr key={c.key}>
              <th className={TH}>{c.label}</th>
              {FIN.map((f) => <td key={f.key} className={TDC} data-testid={`odia-sec6-${c.key}-${f.key}`}>{dashIfInactive(c.key, monthly.section6[c.key][f.key])}</td>)}
            </tr>
          ))}
        </tbody>
      </table>

      <table className="mt-2 w-full border-collapse">
        <thead>
          <tr><th colSpan={5} className={TH}>୭. ଚାଉଳର ବିବରଣୀ (କିଲୋଗ୍ରାମରେ)</th></tr>
          <tr>
            <th className={TH}> </th>
            {FIN.map((f) => <th key={f.key} className={TH}>{f.label}</th>)}
          </tr>
        </thead>
        <tbody>
          {CATEGORIES.map((c) => (
            <tr key={c.key}>
              <th className={TH}>{c.label}</th>
              {FIN.map((f) => {
                const v = monthly.section7[c.key][f.key];
                const isFormula = typeof v === "string" && (v.includes("+") || v.includes("="));
                const display = v === "" || v === undefined || v === null
                  ? ""
                  : isFormula
                    ? v
                    : Number(v).toFixed(3);
                return <td key={f.key} className={TDC} data-testid={`odia-sec7-${c.key}-${f.key}`}>{dashIfInactive(c.key, display)}</td>;
              })}
            </tr>
          ))}
        </tbody>
      </table>

      <table className="mt-2 w-full border-collapse">
        <thead>
          <tr><th colSpan={7} className={TH}>୮. ପାଟିକା ଓ ସହାୟିକାଙ୍କ ବିବରଣୀ</th></tr>
          <tr>
            <th className={TH}>କ୍ର ନଂ</th>
            <th className={TH}>ପାଟିକା ଓ ସହାୟିକାଙ୍କ ନାମ</th>
            <th className={TH}>ଲିଙ୍ଗ (M/F)</th>
            <th className={TH}>ବର୍ଗ (SC/ST/OBC/GEN)</th>
            <th className={TH}>ବ୍ୟାଙ୍କ ଖାତା ନଂ</th>
            <th className={TH}>IFSC / ବ୍ୟାଙ୍କ ଶାଖା</th>
            <th className={TH}>ଅର୍ଥର ପରିମାଣ</th>
          </tr>
        </thead>
        <tbody>
          {bankRows.map((a, i) => (
            <tr key={i}>
              <td className={`${TD} text-center`}>{a.slNo}</td>
              <td className={TD}>{a.committeeName}</td>
              <td className={`${TD} text-center`}>{a.gender || ""}</td>
              <td className={`${TD} text-center`}>{a.category || ""}</td>
              <td className={TD}>{a.bankAccountNo}</td>
              <td className={TD}>{a.ifscBranchName}</td>
              <td className={`${TD} text-right`}>{a.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mdcf-page-break" />

      <table className="mt-2 w-full border-collapse">
        <thead>
          <tr><th colSpan={4} className={TH}>୯. ଅନ୍ୟାନ୍ୟ ଖର୍ଚ୍ଚ (ହାତ ଧୁଆ, ଆସବାବ ପତ୍ର, ପରିଚାଳନା)</th></tr>
          <tr>{FIN.map((f) => <th key={f.key} className={TH}>{f.label}</th>)}</tr>
        </thead>
        <tbody>
          <tr>{FIN.map((f) => <td key={f.key} className={TD}>{monthly.section9[f.key]}</td>)}</tr>
        </tbody>
      </table>

      <table className="mt-2 w-full border-collapse">
        <thead>
          <tr><th colSpan={9} className={TH}>୧୦. ଚାଉଳ ବ୍ୟତୀତ ଅନ୍ୟାନ୍ୟ ସାମଗ୍ରୀ</th></tr>
          <tr>
            <th className={TH} rowSpan={2}>ଜିନିଷର ନାମ</th>
            <th colSpan={2} className={TH}>ବାଲ ବାଟିକା</th>
            <th colSpan={2} className={TH}>ପ୍ରାଥମିକ</th>
            <th colSpan={2} className={TH}>ଉଚ୍ଚ ପ୍ରାଥମିକ</th>
            <th colSpan={2} className={TH}>ଉଚ୍ଚ ବିଦ୍ୟାଳୟ</th>
          </tr>
          <tr>
            {["ପରିମାଣ", "ମୂଲ୍ୟ", "ପରିମାଣ", "ମୂଲ୍ୟ", "ପରିମାଣ", "ମୂଲ୍ୟ", "ପରିମାଣ", "ମୂଲ୍ୟ"].map((x, i) => (
              <th key={i} className={TH}>{x}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {monthly.groceries.map((it, i) => {
            const u = it.unit || "";
            // Render qty as "<value> <unit>" (e.g., "100 gm"); empty stays empty; "--" stays "--"
            const qtyCell = (k, v) => {
              if (!isClassActive(k)) return "--";
              if (v === "" || v === undefined || v === null) return "";
              return u ? `${v} ${u}` : `${v}`;
            };
            // Price cell — 2 decimal places always (e.g., 7.10 not 7.1)
            const priceCell = (k, v) => {
              if (!isClassActive(k)) return "--";
              if (v === "" || v === undefined || v === null) return "";
              const n = Number(v);
              return Number.isFinite(n) ? n.toFixed(2) : v;
            };
            return (
              <tr key={i}>
                <td className={TD}>{it.name}</td>
                <td className={`${TD} text-right`}>{qtyCell("balBatika", it.balBatika_qty)}</td>
                <td className={`${TD} text-right`}>{priceCell("balBatika", it.balBatika_price)}</td>
                <td className={`${TD} text-right`}>{qtyCell("primaryClass", it.primary_qty)}</td>
                <td className={`${TD} text-right`}>{priceCell("primaryClass", it.primary_price)}</td>
                <td className={`${TD} text-right`}>{qtyCell("upperPrimaryClass", it.upperPrimary_qty)}</td>
                <td className={`${TD} text-right`}>{priceCell("upperPrimaryClass", it.upperPrimary_price)}</td>
                <td className={`${TD} text-right`}>{qtyCell("upperSchool", it.upperSchool_qty)}</td>
                <td className={`${TD} text-right`}>{priceCell("upperSchool", it.upperSchool_price)}</td>
              </tr>
            );
          })}
          {(() => {
            // Total ପରିମାଣ = total meals served for that class (sum of attendance over month)
            // Total ମୂଲ୍ୟ = sum of grocery prices (existing behaviour) shown to 2 decimals
            const totalMeals = monthly.section10TotalMeals || { balBatika: 0, primaryClass: 0, upperPrimaryClass: 0, upperSchool: 0 };
            const mealCell = (k) => {
              if (!isClassActive(k)) return "--";
              const n = Number(totalMeals[k]) || 0;
              return n > 0 ? String(n) : "";
            };
            const priceTot = (k, prefix) => {
              if (!isClassActive(k)) return "--";
              const t = monthly.groceries.reduce((s, it) => s + num(it[`${prefix}_price`]), 0);
              return t === 0 ? "" : t.toFixed(2);
            };
            return (
              <tr className="font-bold">
                <td className={TD}>ମୋଟ</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-qty-balBatika">{mealCell("balBatika")}</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-price-balBatika">{priceTot("balBatika", "balBatika")}</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-qty-primary">{mealCell("primaryClass")}</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-price-primary">{priceTot("primaryClass", "primary")}</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-qty-upperPrimary">{mealCell("upperPrimaryClass")}</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-price-upperPrimary">{priceTot("upperPrimaryClass", "upperPrimary")}</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-qty-upperSchool">{mealCell("upperSchool")}</td>
                <td className={`${TD} text-right`} data-testid="odia-sec10-total-price-upperSchool">{priceTot("upperSchool", "upperSchool")}</td>
              </tr>
            );
          })()}
        </tbody>
      </table>

      <table className="mt-2 w-full border-collapse">
        <thead>
          <tr><th colSpan={3} className={TH}>୧୧. ପରିଦର୍ଶନ ଓ ଭୋଜନ ତଦାରଖର ବିବରଣୀ</th></tr>
          <tr>
            <th className={TH}>ତଦାରଖ କମିଟି ସଦସ୍ୟ / ସଦସ୍ୟା</th>
            <th className={TH}>ଖଣ୍ଡ ଶିକ୍ଷା ଅଧିକାରୀ</th>
            <th className={TH}>ଅନ୍ୟ ସଦସ୍ୟ / ସଦସ୍ୟା</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className={`${TD} h-16`}>{monthly.section11.committeeMember}</td>
            <td className={`${TD} h-16`}>{monthly.section11.blockEducationOfficer}</td>
            <td className={`${TD} h-16`}>{monthly.section11.otherMember}</td>
          </tr>
        </tbody>
      </table>

      <div className="mt-24 grid grid-cols-2 gap-8 text-center text-[12px]">
        <div className="border-t border-black pt-2">ବିଦ୍ୟାଳୟ ପରିଚାଳନା କମିଟି ଅଧ୍ୟକ୍ଷ / ସ୍ୱୟଂସହାୟକ ଗୋଷ୍ଠୀ ସଭାପତିଙ୍କ ଦସ୍ଖତ ଓ ମୋହର</div>
        <div className="border-t border-black pt-2">ବିଦ୍ୟାଳୟ ପ୍ରଧାନଶିକ୍ଷକଙ୍କ ଦସ୍ଖତ ଓ ମୋହର</div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// OdiaMdmReportSimple — "Odia MDM Bill Format 2"
// Colourful, eye-catching, LANDSCAPE A4, TWO pages. Keeps every section of
// the original Odia MDCF (1-11) but visually re-organised with gradient
// section banners (blue/green/orange/purple/red/teal/brown), watermarks,
// striped tables and a striking yellow grand-total row. All values are
// auto-filled from the same `data` payload (general + monthly), so totals
// remain identical to Format-1 / English MDCF.
// ---------------------------------------------------------------------------
export function OdiaMdmReportSimple({ data }) {
  const { general, monthly } = data;
  const monthOdia = general.month ? general.month.split("/")[0].trim() : "";

  // Helpers ----------------------------------------------------------------
  const v = (x) => (x === "" || x == null ? "" : String(x));
  const sumAcross = (sectionKey, field) => {
    const sec = monthly?.[sectionKey] || {};
    let t = 0;
    ["balBatika", "primaryClass", "upperPrimaryClass", "upperSchool"].forEach((k) => {
      const val = sec?.[field]?.[k];
      if (val === "" || val == null) return;
      const n = parseFloat(val);
      if (!Number.isNaN(n)) t += n;
    });
    return t;
  };
  const sumFin = (sectionKey, finKey) => {
    const sec = monthly?.[sectionKey] || {};
    let t = 0;
    ["balBatika", "primaryClass", "upperPrimaryClass", "upperSchool"].forEach((k) => {
      const val = sec?.[k]?.[finKey];
      if (val === "" || val == null) return;
      const n = parseFloat(val);
      if (!Number.isNaN(n)) t += n;
    });
    return t;
  };
  const numFmt = (n) => (n ? Number(n).toFixed(2) : "");
  const kgFmt = (n) => (n ? Number(n).toFixed(3) : "");

  const cookRows = [...(monthly?.bankAccounts || [])];
  while (cookRows.length < 4) {
    cookRows.push({ slNo: String(cookRows.length + 1), committeeName: "", bankAccountNo: "", ifscBranchName: "", amount: "" });
  }
  const visitRows = []; // Section 11 doesn't currently store row-level data.
  while (visitRows.length < 4) visitRows.push({});

  // CATEGORIES key-list used to map monthly sections per class
  const CK = ["balBatika", "primaryClass", "upperPrimaryClass", "upperSchool"];

  // iter113 — class-aware rendering for Format 2.
  // If school is e.g. BV+Primary, hide Upper Primary & High School data
  // (show "--"). If ALL classes have 0 enrolment we don't dash anything
  // (probably a freshly-created school still being set up).
  const enrolByClass = general.enrolmentByClass || {
    balBatika: 0, primaryClass: 0, upperPrimaryClass: 0, upperSchool: 0,
  };
  const anyClassEnrolled = (enrolByClass.balBatika + enrolByClass.primaryClass +
    enrolByClass.upperPrimaryClass + enrolByClass.upperSchool) > 0;
  const isClassActive = (k) => !anyClassEnrolled || (enrolByClass[k] || 0) > 0;
  // Render helper for every class cell in Format 2:
  //   - "--" if the school doesn't have that class
  //   - "--" if the value is blank/empty (per user spec: every empty box → "--" centered)
  //   - else the value
  const cell = (k, raw) => {
    if (!isClassActive(k)) return "--";
    if (raw === "" || raw == null || raw === undefined) return "--";
    return raw;
  };
  // For non-class cells (single-value cells) — show "--" if blank.
  const dashIfBlank = (raw) => {
    if (raw === "" || raw == null || raw === undefined) return "--";
    return raw;
  };

  return (
    <div className="mdcf-fmt2-page" data-testid="mdcf-odia-simple-report" lang="or">
      {/* ============================== PAGE 1 ============================== */}
      <div className="mdcf-fmt2 fmt2-pagebreak">
        <div className="watermark">MDM REPORT</div>
        <div className="content">
          <div className="main-title">
            <h1>
              {general.blockNP ? `${general.blockNP} ` : "................ "}
              ବ୍ଲକ ଅନ୍ତର୍ଗତ ବିଦ୍ୟାଳୟ ସମୂହରେ ଚାଲୁରହିଥିବା ମଧ୍ୟାହ୍ନ ଭୋଜନର ମାସିକ ବିବରଣୀ ଫର୍ମ
            </h1>
            <p>ମଧ୍ୟାହ୍ନ ଭୋଜନ ଯୋଜନା — ମାସିକ ରିପୋର୍ଟ</p>
          </div>

          <div className="section-title blue">୧. ବିଦ୍ୟାଳୟର ନାମ / ମାସ / ବର୍ଷ / ମୋଟ ପିଲା</div>
          <table className="info-table">
            <tbody>
              <tr>
                <td><b>ବିଦ୍ୟାଳୟର ନାମ:</b> {general.schoolName || "________________________"}</td>
                <td><b>ବିଦ୍ୟାଳୟର କ୍ର. ନଂ:</b> {general.schoolSerialNo || "__________"}</td>
              </tr>
              <tr>
                <td><b>ମାସ / ବର୍ଷ:</b> {monthOdia}{monthOdia && general.year ? " / " : ""}{general.year || "__________"}</td>
                <td><b>ମୋଟ ପିଲା:</b> {general.totalChildren || "__________"}</td>
              </tr>
            </tbody>
          </table>

          <div className="section-title green">୨. ବିଦ୍ୟାଳୟର ମୋଟ ଶିକ୍ଷାର୍ଥୀ ସଂଖ୍ୟା</div>
          <table className="striped">
            <thead>
              <tr>
                <th>ବିବରଣୀ</th>
                <th>ବାଲ ବାଟିକା</th>
                <th>ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ବିଦ୍ୟାଳୟ</th>
                <th>ମୋଟ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="left">ଶିକ୍ଷାର୍ଥୀ ସଂଖ୍ୟା</td>
                {CK.map((k) => <td key={k}>{cell(k, v(monthly?.section2?.totalStudents?.[k]))}</td>)}
                <td><b>{sumAcross("section2", "totalStudents") || ""}</b></td>
              </tr>
            </tbody>
          </table>

          <div className="section-title orange">୩. ବିଦ୍ୟାଳୟର ମୋଟ କାର୍ଯ୍ୟ ଦିବସ</div>
          <table>
            <thead>
              <tr>
                <th>ବାଲ ବାଟିକା</th>
                <th>ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ବିଦ୍ୟାଳୟ</th>
                <th>ମୋଟ କାର୍ଯ୍ୟ ଦିବସ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {CK.map((k) => <td key={k}>{cell(k, v(monthly?.section2?.totalWorkingDays?.[k]))}</td>)}
                <td><b>{sumAcross("section2", "totalWorkingDays") || ""}</b></td>
              </tr>
            </tbody>
          </table>

          <div className="section-title purple">୪. ମଧ୍ୟାହ୍ନ ଭୋଜନ ପରିବେଷଣ କରାଯାଇଥିବା ଦିନର ପ୍ରକୃତ ସଂଖ୍ୟା</div>
          <table>
            <thead>
              <tr>
                <th>ବାଲ ବାଟିକା</th>
                <th>ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ବିଦ୍ୟାଳୟ</th>
                <th>ମୋଟ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {CK.map((k) => <td key={k}>{cell(k, v(monthly?.section2?.mdmServedDays?.[k]))}</td>)}
                <td><b>{sumAcross("section2", "mdmServedDays") || ""}</b></td>
              </tr>
            </tbody>
          </table>

          <div className="section-title teal">୫. ମାସରେ ପରିବେଷଣ କରାଯାଇଥିବା ମୋଟ ଖାଦ୍ୟ</div>
          <table>
            <thead>
              <tr>
                <th>ବାଲ ବାଟିକା</th>
                <th>ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ପ୍ରାଥମିକ ଶ୍ରେଣୀ</th>
                <th>ଉଚ୍ଚ ବିଦ୍ୟାଳୟ</th>
                <th>ମୋଟ ଖାଦ୍ୟ</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                {CK.map((k) => <td key={k}>{cell(k, v(monthly?.section2?.totalFoodExpense?.[k]))}</td>)}
                <td><b>{numFmt(sumAcross("section2", "totalFoodExpense")) || ""}</b></td>
              </tr>
            </tbody>
          </table>

          <div className="section-title red">୬. ଆର୍ଥିକ ବିବରଣୀ — ଟଙ୍କାରେ</div>
          <table className="fin striped">
            <thead>
              <tr>
                <th>ବିଭାଗ</th>
                {FIN.map((f) => <th key={f.key}>{f.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {CATEGORIES.map((c) => (
                <tr key={c.key}>
                  <td className="left">{c.label}</td>
                  {FIN.map((f) => <td key={f.key}>{cell(c.key, v(monthly?.section6?.[c.key]?.[f.key]))}</td>)}
                </tr>
              ))}
              <tr className="total-row">
                <th className="left">ମୋଟ</th>
                {FIN.map((f) => <th key={f.key}>{numFmt(sumFin("section6", f.key)) || ""}</th>)}
              </tr>
            </tbody>
          </table>

          <div className="section-title brown">୭. ଚାଉଳର ବିବରଣୀ — କିଲୋଗ୍ରାମରେ</div>
          <table className="rice striped">
            <thead>
              <tr>
                <th>ବିଭାଗ</th>
                {FIN.map((f) => <th key={f.key}>{f.label}</th>)}
              </tr>
            </thead>
            <tbody>
              {CATEGORIES.map((c) => (
                <tr key={c.key}>
                  <td className="left">{c.label}</td>
                  {FIN.map((f) => {
                    if (!isClassActive(c.key)) return <td key={f.key}>--</td>;
                    const val = monthly?.section7?.[c.key]?.[f.key];
                    const isFormula = typeof val === "string" && (val.includes("+") || val.includes("="));
                    const display = val === "" || val == null
                      ? "--"
                      : isFormula ? val : Number(val).toFixed(3);
                    return <td key={f.key}>{display}</td>;
                  })}
                </tr>
              ))}
              <tr className="total-row">
                <th className="left">ମୋଟ</th>
                {FIN.map((f) => <th key={f.key}>{kgFmt(sumFin("section7", f.key)) || ""}</th>)}
              </tr>
            </tbody>
          </table>

          <div className="section-title blue">୮. ପାଚିକା ଓ ସହାୟିକାଙ୍କ ବିବରଣୀ</div>
          <table className="helper">
            <thead>
              <tr>
                <th>କ୍ର. ନଂ</th>
                <th>ପାଚିକା ଓ ସହାୟିକାଙ୍କ ନାମ</th>
                <th>ବ୍ୟାଙ୍କ ଖାତା ନଂ</th>
                <th>ଆଇଏଫଏସ କୋଡ୍ ନଂ</th>
                <th>ବ୍ୟାଙ୍କ ଶାଖାର ନାମ</th>
                <th>ଅର୍ଥର ପରିମାଣ</th>
              </tr>
            </thead>
            <tbody>
              {cookRows.slice(0, 4).map((r, i) => (
                <tr key={i}>
                  <td>{r.slNo || (i + 1)}</td>
                  <td>{r.committeeName || ""}</td>
                  <td>{r.bankAccountNo || ""}</td>
                  <td>{(r.ifscBranchName || "").split("/")[0] || ""}</td>
                  <td>{(r.ifscBranchName || "").split("/").slice(1).join("/").trim() || ""}</td>
                  <td>{r.amount || ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ============================== PAGE 2 ============================== */}
      <div className="mdcf-fmt2">
        <div className="watermark">MDM REPORT</div>
        <div className="content">
          <div className="main-title">
            <h1>ମଧ୍ୟାହ୍ନ ଭୋଜନ ମାସିକ ବିବରଣୀ — ଅନ୍ୟାନ୍ୟ ଖର୍ଚ୍ଚ ଓ ସାମଗ୍ରୀ</h1>
            <p>
              ବିଦ୍ୟାଳୟର ନାମ: {general.schoolName || "____________________________"}
              &nbsp;&nbsp; ମାସ / ବର୍ଷ: {monthOdia}{monthOdia && general.year ? " / " : ""}{general.year || "__________"}
            </p>
          </div>

          <div className="section-title orange">୯. ଅନ୍ୟାନ୍ୟ ଖର୍ଚ୍ଚ ଯଥା — ହାତ ଧୁଆ, ଆସବାବ ପତ୍ର କିଣା, ପରିଚାଳନା</div>
          <table>
            <thead>
              <tr>
                <th>ବିବରଣୀ</th>
                {FIN.map((f) => <th key={f.key}>{f.label}</th>)}
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="left">ହାତ ଧୁଆ, ଆସବାବ ପତ୍ର କିଣା, ପରିଚାଳନା</td>
                {FIN.map((f) => <td key={f.key}>{dashIfBlank(v(monthly?.section9?.[f.key]))}</td>)}
              </tr>
            </tbody>
          </table>

          <div className="section-title purple">୧୦. ଚାଉଳ ବ୍ୟତୀତ ଅନ୍ୟାନ୍ୟ ସାମଗ୍ରୀ</div>
          <table className="material striped small">
            <thead>
              <tr>
                <th rowSpan={2}>ଜିନିଷର ନାମ</th>
                <th colSpan={2}>ବାଲ ବାଟିକା</th>
                <th colSpan={2}>ପ୍ରାଥମିକ</th>
                <th colSpan={2}>ଉଚ୍ଚ ପ୍ରାଥମିକ</th>
                <th colSpan={2}>ଉଚ୍ଚ ବିଦ୍ୟାଳୟ</th>
              </tr>
              <tr>
                {["ପରିମାଣ", "ମୂଲ୍ୟ", "ପରିମାଣ", "ମୂଲ୍ୟ", "ପରିମାଣ", "ମୂଲ୍ୟ", "ପରିମାଣ", "ମୂଲ୍ୟ"].map((x, i) => (
                  <th key={i}>{x}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(monthly?.groceries || []).map((it, i) => {
                const u = it.unit || "";
                const qty = (val) => (val === "" || val == null ? "--" : (u ? `${val} ${u}` : `${val}`));
                const price = (val) => {
                  if (val === "" || val == null) return "--";
                  const n = Number(val);
                  return Number.isFinite(n) ? n.toFixed(2) : val;
                };
                // iter113 — Show "--" for class columns that don't exist in this school.
                const c2 = (k, val) => (isClassActive(k) ? val : "--");
                return (
                  <tr key={i}>
                    <td className="left">{it.name}</td>
                    <td>{c2("balBatika", qty(it.balBatika_qty))}</td><td>{c2("balBatika", price(it.balBatika_price))}</td>
                    <td>{c2("primaryClass", qty(it.primary_qty))}</td><td>{c2("primaryClass", price(it.primary_price))}</td>
                    <td>{c2("upperPrimaryClass", qty(it.upperPrimary_qty))}</td><td>{c2("upperPrimaryClass", price(it.upperPrimary_price))}</td>
                    <td>{c2("upperSchool", qty(it.upperSchool_qty))}</td><td>{c2("upperSchool", price(it.upperSchool_price))}</td>
                  </tr>
                );
              })}
              {(() => {
                const totalMeals = monthly?.section10TotalMeals || { balBatika: 0, primaryClass: 0, upperPrimaryClass: 0, upperSchool: 0 };
                const meal = (k) => (totalMeals[k] ? String(totalMeals[k]) : "");
                const priceTot = (prefix) => {
                  const t = (monthly?.groceries || []).reduce((s, it) => s + (parseFloat(it[`${prefix}_price`]) || 0), 0);
                  return t === 0 ? "" : t.toFixed(2);
                };
                return (
                  <tr className="total-row">
                    <th className="left">ମୋଟ</th>
                    <th>{cell("balBatika", meal("balBatika"))}</th><th>{cell("balBatika", priceTot("balBatika"))}</th>
                    <th>{cell("primaryClass", meal("primaryClass"))}</th><th>{cell("primaryClass", priceTot("primary"))}</th>
                    <th>{cell("upperPrimaryClass", meal("upperPrimaryClass"))}</th><th>{cell("upperPrimaryClass", priceTot("upperPrimary"))}</th>
                    <th>{cell("upperSchool", meal("upperSchool"))}</th><th>{cell("upperSchool", priceTot("upperSchool"))}</th>
                  </tr>
                );
              })()}
            </tbody>
          </table>

          <div className="section-title teal">୧୧. ପରିଦର୍ଶନ ଓ ଭୋଜନ ତଦାରଖର ବିବରଣୀ</div>
          <table className="visit">
            <thead>
              <tr>
                <th>କ୍ର. ନଂ</th>
                <th>ତାରିଖ</th>
                <th>ପରିଦର୍ଶକ / ସଦସ୍ୟ / ସଦସ୍ୟାଙ୍କ ନାମ</th>
                <th>ପଦବୀ</th>
                <th>ମତାମତ / ଟିପ୍ପଣୀ</th>
                <th>ଦସ୍ତଖତ</th>
              </tr>
            </thead>
            <tbody>
              {/* Map section11 free-text fields into visible rows when populated */}
              {[
                { name: monthly?.section11?.committeeMember, role: "ତଦାରଖ କମିଟି ସଦସ୍ୟ" },
                { name: monthly?.section11?.blockEducationOfficer, role: "ଖଣ୍ଡ ଶିକ୍ଷା ଅଧିକାରୀ" },
                { name: monthly?.section11?.otherMember, role: "ଅନ୍ୟ ସଦସ୍ୟ" },
                { name: "", role: "" },
              ].map((r, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td></td>
                  <td>{r.name || ""}</td>
                  <td>{r.role || ""}</td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="section-title red">ଦସ୍ତଖତ ଓ ମୋହର</div>
          <table>
            <tbody>
              <tr>
                <td className="signature-box">
                  ବିଦ୍ୟାଳୟ ପ୍ରଧାନଶିକ୍ଷକଙ୍କ<br/>ଦସ୍ତଖତ ଓ ମୋହର
                </td>
                <td className="signature-box">
                  ସ୍ୱୟଂ ସହାୟକ ଗୋଷ୍ଠୀ ସଭାପତିଙ୍କ<br/>ଦସ୍ତଖତ ଓ ମୋହର
                </td>
                <td className="signature-box">
                  ବିଦ୍ୟାଳୟ ପରିଚାଳନା କମିଟି ଅଧ୍ୟକ୍ଷ /<br/>ତଦାରଖ କମିଟି ସଦସ୍ୟ / ସଦସ୍ୟା
                </td>
                <td className="signature-box">ବ୍ଲକ ଶିକ୍ଷା ଅଧିକାରୀ</td>
              </tr>
            </tbody>
          </table>

          <div className="note">
            ଟିପ୍ପଣୀ: ଏହି ଫର୍ମରେ ଦିଆଯାଇଥିବା ସମସ୍ତ ଖାଲି ସ୍ଥାନ ଯଥାଯଥ ତଥ୍ୟ ଦ୍ୱାରା ପୂରଣ କରନ୍ତୁ।
          </div>
        </div>
      </div>
    </div>
  );
}

const CB = "inline-block w-[12px] h-[12px] border border-black align-middle";
const CBFilled = `${CB} bg-black`;

export function EngMdcfReport({ data }) {
  const { general: g, eng } = data;
  const monthDef = MONTH_OPTIONS.find((m) => (g.month || "").includes(m.en));
  const monthEng = monthDef?.en || (g.month ? g.month.split("/").pop().trim() : "");

  const typeOpts = ["Government", "Local Body", "EGS/AIE Centers", "NCLP", "Madras / Maqtab"];
  const catOpts = ["Primary", "Upper Primary", "Primary with Upper Primary"];

  // Classwise enrolment from school profile (set by autoFillMdcf in lib/mdcf.js).
  // English MDCF tracks BV / Primary / UP only (not High School).
  // Map English keys → enrolmentByClass keys.
  const enrol = g.enrolmentByClass || { balBatika: 0, primaryClass: 0, upperPrimaryClass: 0, upperSchool: 0 };
  const ENG_TO_ENROL = { balVatika: "balBatika", primary: "primaryClass", upperPrimary: "upperPrimaryClass" };
  const anyEnrolled = (enrol.balBatika + enrol.primaryClass + enrol.upperPrimaryClass + enrol.upperSchool) > 0;
  const isEngActive = (engKey) => !anyEnrolled || (enrol[ENG_TO_ENROL[engKey]] || 0) > 0;
  const dashIfEngInactive = (engKey, v) => (isEngActive(engKey) ? v : "--");

  // Mapping: fundDetails / grainDetails row key → enrolment class key (only for cooking-cost / rice classwise rows)
  const FUND_ENG_TO_ENROL = {
    cookingCostBalVatika: "balVatika",
    cookingCostPrimary: "primary",
    cookingCostUpperPrimary: "upperPrimary",
  };
  const GRAIN_ENG_TO_ENROL = {
    balVatikaWheat: "balVatika",
    balVatikaRice: "balVatika",
    primaryWheat: "primary",
    primaryRice: "primary",
    upperPrimaryWheat: "upperPrimary",
    upperPrimaryRice: "upperPrimary",
  };

  const cookRows = [...eng.cookDetails];
  while (cookRows.length < 4) {
    cookRows.push({ slNo: String(cookRows.length + 1), cookName: "", gender: "", category: "", paymentMode: "", amountReceived: "" });
  }

  const FUND = [
    { key: "cookingCostBalVatika", label: "Cooking Cost - Bal Vatika" },
    { key: "cookingCostPrimary", label: "Cooking Cost - Primary" },
    { key: "cookingCostUpperPrimary", label: "Cooking Cost - Upper Primary" },
    { key: "cookCumHelper", label: "Cook Cum Helper" },
    { key: "mmeExpenses", label: "School Expenses : MME Expenses" },
  ];
  const GRAIN = [
    { key: "balVatikaWheat", cat: "Bal Vatika", item: "Wheat" },
    { key: "balVatikaRice", cat: "", item: "Rice" },
    { key: "primaryWheat", cat: "Primary", item: "Wheat" },
    { key: "primaryRice", cat: "", item: "Rice" },
    { key: "upperPrimaryWheat", cat: "Upper Primary", item: "Wheat" },
    { key: "upperPrimaryRice", cat: "", item: "Rice" },
  ];

  const MEAL = [
    { key: "enrolment", label: "Enrolment during the month" },
    { key: "schoolDays", label: "Number of School days during month" },
    { key: "mdmDaysServed", label: "Actual number of days Mid Day Meal served" },
    { key: "totalMealsServed", label: "Total Meals served during the month" },
  ];

  return (
    <div className="mdcf-page bg-white p-8 text-ink-900" data-testid="mdcf-eng-report">
      <h2 className="text-center text-[16px] font-bold">Pradhan Mantri Poshan Shakti Nirman (PM POSHAN)</h2>
      <h3 className="text-center text-[14px] font-bold">School Monthly Data Capture Format (MDCF)</h3>
      <p className="mt-2 text-[11.5px]"><b>Instructions:</b> Keep following registers at the time of filling the form:</p>
      <p className="text-[11.5px]"><b>1)</b> Enrolment Register. <b>2)</b> Account. <b>3)</b> Bank Account Pass book. <b>4)</b> Cooking cost details etc.</p>

      <h4 className="mt-3 text-[13px] font-bold">1. School Details</h4>
      <table className="w-full border-collapse">
        <tbody>
          <tr>
            <th className={TH}>Month-Year</th>
            <td className={TD}>{monthEng} {g.year}</td>
            <th className={TH}>UDISE Code</th>
            <td className={TD}>{g.udiseCode}</td>
            <th className={TH}>School Name</th>
            <td className={TD} colSpan={3}>{g.schoolName}</td>
          </tr>
          <tr>
            <th className={TH}>Type</th>
            <td className={TD} colSpan={7}>
              {typeOpts.map((t) => (
                <span key={t} className="mr-3">
                  <span className={g.schoolType === t ? CBFilled : CB} /> {t}
                </span>
              ))}
            </td>
          </tr>
          <tr>
            <th className={TH}>Category</th>
            <td className={TD} colSpan={7}>
              {catOpts.map((c) => (
                <span key={c} className="mr-3">
                  <span className={g.category === c ? CBFilled : CB} /> {c}
                </span>
              ))}
            </td>
          </tr>
          <tr>
            <th className={TH}>State / UT</th><td className={TD}>{g.stateUT}</td>
            <th className={TH}>District</th><td className={TD}>{g.district}</td>
            <th className={TH}>Block / NP</th><td className={TD}>{g.blockNP}</td>
            <th className={TH}>Village / Ward</th><td className={TD}>{g.villageWard}</td>
          </tr>
          <tr>
            <th className={TH}>Kitchen Type</th><td className={TD}>{g.kitchenType}</td>
            <th className={TH}>NGO / SHG</th><td className={TD}>{g.ngoShg}</td>
            <th className={TH}>Enrolment</th><td className={TD} colSpan={3}>{g.enrolment}</td>
          </tr>
        </tbody>
      </table>

      <h4 className="mt-3 text-[13px] font-bold">2. Meals Availed Status</h4>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className={TH}> </th>
            <th className={TH}>Bal Vatika</th>
            <th className={TH}>Primary</th>
            <th className={TH}>Upper Primary</th>
          </tr>
        </thead>
        <tbody>
          {MEAL.map((r) => (
            <tr key={r.key}>
              <th className={`${TH} text-left`}>{r.label}</th>
              <td className={TDC} data-testid={`eng-meals-${r.key}-balVatika`}>{dashIfEngInactive("balVatika", eng.mealsAvailed[r.key].balVatika)}</td>
              <td className={TDC} data-testid={`eng-meals-${r.key}-primary`}>{dashIfEngInactive("primary", eng.mealsAvailed[r.key].primary)}</td>
              <td className={TDC} data-testid={`eng-meals-${r.key}-upperPrimary`}>{dashIfEngInactive("upperPrimary", eng.mealsAvailed[r.key].upperPrimary)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h4 className="mt-3 text-[13px] font-bold">3. Fund Details (in Rs.)</h4>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className={TH}>Component</th>
            <th className={TH}>Opening Balance</th>
            <th className={TH}>Received during the Month</th>
            <th className={TH}>Expenditure during the Month</th>
            <th className={TH}>Closing Balance</th>
          </tr>
        </thead>
        <tbody>
          {FUND.map((r) => {
            // For the 3 cookingCost rows, dash when class not enrolled. cookCumHelper + mmeExpenses are not classwise so always show.
            const engKey = FUND_ENG_TO_ENROL[r.key];
            const dashOrShow = (v) => (engKey ? dashIfEngInactive(engKey, v) : v);
            return (
            <tr key={r.key}>
              <th className={`${TH} text-left`}>{r.label}</th>
              <td className={TDC} data-testid={`eng-fund-${r.key}-opening`}>{dashOrShow(eng.fundDetails[r.key].openingBalance)}</td>
              <td className={TDC} data-testid={`eng-fund-${r.key}-received`}>{dashOrShow(eng.fundDetails[r.key].receivedDuringMonth)}</td>
              <td className={TDC} data-testid={`eng-fund-${r.key}-expenditure`}>{dashOrShow(eng.fundDetails[r.key].expenditureDuringMonth)}</td>
              <td className={TDC} data-testid={`eng-fund-${r.key}-closing`}>{dashOrShow(eng.fundDetails[r.key].closingBalance)}</td>
            </tr>
            );
          })}
        </tbody>
      </table>
      <p className="mt-1 text-[11.5px]">
        Whether the Sum of above Closing Balance matches with Bank Account Closing Balance.{" "}
        <span className={eng.fundDetails.closingMatchesBank === "Yes" ? CBFilled : CB} /> Yes{" "}
        <span className={eng.fundDetails.closingMatchesBank === "No" ? CBFilled : CB} /> No
      </p>

      <h4 className="mt-3 text-[13px] font-bold">4. Cook Cum Helper Payment Details</h4>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className={TH}>S.No.</th>
            <th className={TH}>Cook Name</th>
            <th className={TH}>Gender (M/F)</th>
            <th className={TH}>Category (SC/ST/OBC/GEN)</th>
            <th className={TH}>Payment Mode (Cash/Bank)</th>
            <th className={TH}>Amount Received during month (In Rs.)</th>
          </tr>
        </thead>
        <tbody>
          {cookRows.map((c, i) => (
            <tr key={i}>
              <td className={`${TD} text-center`}>{c.slNo}</td>
              <td className={TD}>{c.cookName}</td>
              <td className={TD}>{c.gender}</td>
              <td className={TD}>{c.category}</td>
              <td className={TD}>{c.paymentMode}</td>
              <td className={`${TD} text-right`}>{c.amountReceived}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="mdcf-page-break" />

      <h4 className="mt-3 text-[13px] font-bold">5. Food Grains Details (in KG.)</h4>
      <table className="w-full border-collapse">
        <thead>
          <tr>
            <th className={TH}>Category</th>
            <th className={TH}>Food Item</th>
            <th className={TH}>Opening Balance</th>
            <th className={TH}>Received during the Month</th>
            <th className={TH}>Consumption during the Month</th>
            <th className={TH}>Closing Balance</th>
          </tr>
        </thead>
        <tbody>
          {GRAIN.map((r) => {
            const engKey = GRAIN_ENG_TO_ENROL[r.key];
            const dashOrShow = (v) => (engKey ? dashIfEngInactive(engKey, v) : v);
            const cons = eng.grainDetails[r.key].consumptionDuringMonth;
            const isFormula = typeof cons === "string" && (cons.includes("+") || cons.includes("="));
            const consDisplay = cons === "" || cons === undefined || cons === null
              ? ""
              : isFormula
                ? cons
                : Number(cons).toFixed(3);
            return (
              <tr key={r.key}>
                <td className={TD}>{r.cat}</td>
                <td className={TD}>{r.item}</td>
                <td className={TDC} data-testid={`eng-grain-${r.key}-opening`}>{dashOrShow(eng.grainDetails[r.key].openingBalance)}</td>
                <td className={TDC} data-testid={`eng-grain-${r.key}-received`}>{dashOrShow(eng.grainDetails[r.key].receivedDuringMonth)}</td>
                <td className={TDC} data-testid={`eng-grain-${r.key}-consumption`}>{dashOrShow(consDisplay)}</td>
                <td className={TDC} data-testid={`eng-grain-${r.key}-closing`}>{dashOrShow(eng.grainDetails[r.key].closingBalance)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <h4 className="mt-3 text-[13px] font-bold">6. Children Health Status</h4>
      <table className="w-full border-collapse">
        <tbody>
          {[
            { k: "ifaBoys", l: "No. of children from class 1 to 8 who had received 4 IFA tablets (Boys)" },
            { k: "ifaGirls", l: "No. of children from class 1 to 8 who had received 4 IFA tablets (Girls)" },
            { k: "rbskScreened", l: "No. of children screened by mobile health (RBSK) team" },
            { k: "rbskReferred", l: "No. of children referred by mobile health (RBSK) team" },
          ].map((r) => (
            <tr key={r.k}>
              <th className={`${TH} text-left`}>{r.l}</th>
              <td className={`${TD} w-24 text-right`}>{eng.healthStatus[r.k]}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h4 className="mt-3 text-[13px] font-bold">7. School Inspection</h4>
      <table className="w-full border-collapse">
        <tbody>
          <tr>
            <th className={`${TH} text-left`}>School Inspection done during the month</th>
            <td className={TD}>
              <span className={eng.inspection.inspectionDone === "Yes" ? CBFilled : CB} /> <b>Yes</b>{" "}
              <span className={`ml-4 ${eng.inspection.inspectionDone === "No" ? CBFilled : CB}`} /> <b>No</b>
            </td>
          </tr>
          <tr><th className={`${TH} text-left`}>By Members of Task Force</th><td className={TD}>{eng.inspection.byTaskForce}</td></tr>
          <tr><th className={`${TH} text-left`}>By District Officials</th><td className={TD}>{eng.inspection.byDistrictOfficials}</td></tr>
          <tr><th className={`${TH} text-left`}>By Block / Taluka Level Officials</th><td className={TD}>{eng.inspection.byBlockOfficials}</td></tr>
          <tr><th className={`${TH} text-left`}>By SMC Members</th><td className={TD}>{eng.inspection.bySMCMembers}</td></tr>
          <tr><th className={`${TH} text-left`}>Number of Untoward Incidents Occurred</th><td className={TD}>{eng.inspection.untowardIncidents}</td></tr>
        </tbody>
      </table>

      <div className="mt-20 grid grid-cols-2 gap-8 text-center text-[12px]">
        <div>
          <p>.....................................................</p>
          <p>Signature of the SMC Chairperson / Gram Pradhan</p>
        </div>
        <div>
          <p>................................................................</p>
          <p>Signature of Head Teacher</p>
        </div>
      </div>
    </div>
  );
}
